import { useEffect, useState } from 'react';
import { useSocketStore } from '../../stores/useSocketStore';

function useEnsureTripByCodigoDate({
    enabled = true,
    tripToday,
    codigo,
    selectedDay
}) {

    const socket = useSocketStore(state => state.socket);

    const [trip, setTrip] = useState(null);
    const [status, setStatus] = useState('idle');

    const selectedDate =
        selectedDay?.date?.format('YYYY-MM-DD') ?? null;

    const isToday =
        selectedDay?.isToday ?? false;

    useEffect(() => {

        if (
            !enabled ||
            !socket ||
            !codigo ||
            !selectedDate
        ) {
            setTrip(null);
            setStatus('idle');
            return;
        }

        // Se a viagem de hoje já veio junto com a linha,
        // não precisamos buscá-la novamente.
        if (isToday && tripToday) {
            setTrip(null);
            setStatus('idle');
            return;
        }

        let cancelled = false;

        setTrip(null);
        setStatus('loading');

        socket.emit(
            'trip:by-codigo-date',
            {
                date: selectedDate,
                codigo
            },
            res => {

                // O effect já foi invalidado.
                // Ignora uma eventual resposta antiga.
                if (cancelled) {
                    return;
                }

                if (!res) {
                    setStatus('error');
                    return;
                }

                if (res.status === 'found') {

                    setTrip(res.trip);
                    setStatus('done');
                    return;

                }

                if (res.status === 'not_found') {

                    setTrip(null);
                    setStatus('not_found');
                    return;

                }

                setStatus('error');
            }
        );

        return () => {
            cancelled = true;
        };

    }, [
        enabled,
        socket,
        codigo,
        selectedDate,
        isToday,
        tripToday
    ]);

    return {
        trip,
        status,
        isLoading: status === 'loading',
        resolved: status === 'done',
        failed: status === 'not_found'
    };
}

export default useEnsureTripByCodigoDate;